import React, { Component } from 'react';
import { Form, Field } from 'react-final-form';
import isEqual from 'lodash/isEqual';
import { TextAreaField, TextField } from '../../atoms';
import { getLoadingSelector } from '../../utils/asyncHelpers';
import { Row, Col, Button, Spin } from 'antd';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FileUpload, FormActions } from '../../components';
import { withTranslation } from 'react-i18next';
import { NAMESPACES } from '../../i18n';
import { FORM_REQUEST_CHANGE } from '../../constants/formKeys';
import { getUserLegalEntityName } from '../../reducers/userReducer';
import { notificationRelatedObjectType } from '../../constants/classificators';
import { getChangeRequest } from '../../reducers/requestChangeReducer';
import * as actions from '../../actions/actionCreators/requestChangeActionCreators';
import { formRequestChangeFields } from '../../constants/forms/formRequestChange';
import { makeRffValidateFromLegacy } from '../rffLegacyValidateAdapter';
import validateSchema from './validateSchema';
import FormStateToRedux from '../FormStateToRedux';

export class RequestChange extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    onComplete: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    relatedObjectId: PropTypes.number.isRequired,
    relatedObjectType: PropTypes.string.isRequired,
    isLoading: PropTypes.bool.isRequired,
    initialValues: PropTypes.object.isRequired,
    requestChangeLegalEntity: PropTypes.func.isRequired,
    requestChangeProductionUnit: PropTypes.func.isRequired,
    requestChangeMeteringPoint: PropTypes.func.isRequired,
  };

  onFileChange = (info) => {
    if (['done', 'removed'].includes(info.file.status)) {
      this._form.change(
        formRequestChangeFields.FILE_IDS,
        info.fileList.map((file) => file.response)
      );
    }
  };

  onSubmit = async (values) => {
    const typeToActionMap = {
      [notificationRelatedObjectType.LEGAL_ENTITY]:
        this.props.requestChangeLegalEntity,
      [notificationRelatedObjectType.PRODUCTION_UNIT]:
        this.props.requestChangeProductionUnit,
      [notificationRelatedObjectType.MEASUREMENT_POINT]:
        this.props.requestChangeMeteringPoint,
    };
    const result = await typeToActionMap[this.props.relatedObjectType](values);
    if (!result?.error) {
      this.props.onComplete();
    }
  };

  render() {
    const { t, onCancel, isLoading, initialValues } = this.props;
    const validate = makeRffValidateFromLegacy(validateSchema, this.props);

    return (
      <Form
        onSubmit={this.onSubmit}
        validate={validate}
        initialValues={initialValues}
        initialValuesEqual={isEqual}
        render={({ handleSubmit, form }) => {
          this._form = form;
          return (
            <Spin spinning={isLoading}>
              <form onSubmit={handleSubmit} className="form-request-change">
                <FormStateToRedux form={FORM_REQUEST_CHANGE} />
                <Row gutter={32}>
                  <Col span={12}>
                    <Field
                      name={formRequestChangeFields.SENDER}
                      label={t('sender')}
                      component={TextField}
                      disabled
                      hasFeedback={false}
                    />
                  </Col>
                  <Col span={12}>
                    <Field
                      name={formRequestChangeFields.RECEIVER}
                      label={t('receiver')}
                      component={TextField}
                      disabled
                      hasFeedback={false}
                    />
                  </Col>
                </Row>
                <Field
                  name={formRequestChangeFields.MESSAGE}
                  label={t('message')}
                  component={TextAreaField}
                  rows={6}
                />
                <FileUpload t={t} onChange={this.onFileChange} />
                <FormActions>
                  <Button onClick={onCancel}>{t('cancel')}</Button>
                  <Button htmlType="submit" type="primary">
                    {t('send')}
                  </Button>
                </FormActions>
              </form>
            </Spin>
          );
        }}
      />
    );
  }
}

const getIsLoading = getLoadingSelector(getChangeRequest);

const mapStateToProps = (state, ownProps) => ({
  initialValues: {
    [formRequestChangeFields.FILE_IDS]: [],
    [formRequestChangeFields.RECEIVER]: ownProps.t('eleringAdmin'),
    [formRequestChangeFields.SENDER]: getUserLegalEntityName(state),
    [formRequestChangeFields.RELATED_OBJECT_ID]: ownProps.relatedObjectId,
  },
  isLoading: getIsLoading(state),
});

const mapDispatchToProps = {
  requestChangeLegalEntity: actions.requestChangeLegalEntity,
  requestChangeProductionUnit: actions.requestChangeProductionUnit,
  requestChangeMeteringPoint: actions.requestChangeMeteringPoint,
};

export default withTranslation(NAMESPACES.requestChange)(
  connect(mapStateToProps, mapDispatchToProps)(RequestChange)
);
